// extracted by mini-css-extract-plugin
export default {"btn-primary":"_api-keys-table_btn-primary__PXz6D","reveal-keys":"_api-keys-table_reveal-keys__FK-cV"};